import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MatDialogModule } from '@angular/material/dialog';
// icons
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';

// perfect scrollbar
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgxSpinnerModule } from "ngx-spinner";
//import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
//Import all material modules
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//Import Layouts
import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { BillingFormComponent } from './layouts/billing-form/billing-form.component';

import { FilterPipe } from './pipe/filter.pipe';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ApiModule } from './api/api.module';
import { apiBaseUrlGetter } from './utils/appInitializer';
import { JwtModule } from '@auth0/angular-jwt';
import { blacklistedRoutesGetter, tokenGetter, whitelistedDomainsGetter } from './utils/jwtUtls';
import { JWTAuthInterceptor } from './utils/jwtauth.interceptor';
import { SpinInterceptor } from './utils/spinInterceptor';
import { registerLocaleData } from '@angular/common';
import localeTh from '@angular/common/locales/th';
import localeEn from '@angular/common/locales/en';

registerLocaleData(localeTh, 'th-TH');
registerLocaleData(localeEn);
export function HttpLoaderFactory(http: HttpClient): any {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent, BlankComponent, BillingFormComponent, FilterPipe],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    //CKEditorModule,
    BrowserAnimationsModule,
    CarouselModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    MaterialModule,
    TablerIconsModule.pick(TablerIcons),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      defaultLanguage: "th"
    }),
    NgScrollbarModule,
    FullComponent,
    MatDialogModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        allowedDomains: [whitelistedDomainsGetter()],
        disallowedRoutes: blacklistedRoutesGetter(),
        throwNoTokenError: false
      },
    }),
    ApiModule.forRoot({ rootUrl: apiBaseUrlGetter() }),
  ],
  exports: [TablerIconsModule],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JWTAuthInterceptor,
      multi: true
    },
    {
      // Shows the global <ngx-spinner> overlay (app.component.html) while any API call is in flight
      provide: HTTP_INTERCEPTORS,
      useClass: SpinInterceptor,
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'th-TH' } 
  ]
})
export class AppModule {}
